/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsAddServiceMutationVariables = {
    accountID: string;
    name: string;
    description: string;
};
export type mutationsAddServiceMutationResponse = {
    readonly addService: {
        readonly id: string;
    };
};
export type mutationsAddServiceMutation = {
    readonly response: mutationsAddServiceMutationResponse;
    readonly variables: mutationsAddServiceMutationVariables;
};



/*
mutation mutationsAddServiceMutation(
  $accountID: ID!
  $name: String!
  $description: String!
) {
  addService(input: {accountID: $accountID, name: $name, description: $description}) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accountID",
            "variableName": "accountID"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "addService",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsAddServiceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mutationsAddServiceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cbccae248cfdb2788a69231d57e646d7",
    "id": null,
    "metadata": {},
    "name": "mutationsAddServiceMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsAddServiceMutation(\n  $accountID: ID!\n  $name: String!\n  $description: String!\n) {\n  addService(input: {accountID: $accountID, name: $name, description: $description}) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b0a33274005b315b19e264f7468ff811';
export default node;
